const IF = (condition: boolean, value: number | string, defaultValue: number | string) =>
  condition ? value : defaultValue;

export default IF;
